import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'

import { seoGuideApiToSectionsFormat } from 'helpers/seoGuideUtils'

import * as actions from 'redux/actions/seoChecklist.actions'

function* loadChecklistSaga(params) {
  try {
    const { domainId } = params.payload
    const body = yield call(agent.SeoChecklist.getAll, domainId)
    const checklist = seoGuideApiToSectionsFormat(body.data.attributes)

    yield put(actions.loadChecklistSuccess(domainId, checklist))
  } catch (error) {
    yield put(actions.loadChecklistFailure(error))
  }
}

function* updateChecklistSaga(params) {
  try {
    const { domainId, section, checklist } = params.payload
    yield call(agent.SeoChecklist.update, domainId, checklist)
    yield put(actions.updateChecklistSuccess(domainId, section, checklist))
  } catch (error) {
    yield put(actions.updateChecklistFailure(error))
  }
}

function* getSeoChecklistDomainsSaga() {
  try {
    const body = yield call(agent.SeoChecklist.getDomains)
    const data = body.data.map(item => item.attributes)
    yield put(actions.getSeoChecklistDomainsSuccess(data))
  } catch (error) {
    yield put(actions.getSeoChecklistDomainsFailure(error))
  }
}

export default function* checklistSagas() {
  yield all([
    takeLatest(actions.loadChecklist.type, loadChecklistSaga),
    takeLatest(actions.updateChecklist.type, updateChecklistSaga),
    takeLatest(actions.getSeoChecklistDomains.type, getSeoChecklistDomainsSaga)
  ])
}
